import { create } from "zustand";

type useChooseStoreOpen = {
	isChooseStoreOpen: boolean;
	setChooseStoreOpen: (v: boolean) => void;
	chooseStoreType: string;
	setChooseStoreType: (v: string) => void;
	chooseStoreStyleCode: string;
	setChooseStoreStyleCode: (v: string) => void;
};

export const useChooseStoreOpen = create<useChooseStoreOpen>((set) => ({
	isChooseStoreOpen: false,
	setChooseStoreOpen: (v) => set({ isChooseStoreOpen: v }),
	chooseStoreType: "",
	setChooseStoreType: (v) => set({ chooseStoreType: v }),
	chooseStoreStyleCode: "",
	setChooseStoreStyleCode: (v) => set({ chooseStoreStyleCode: v }),
}));
